import React, { useContext, useMemo } from "react";
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import { Icon } from "leaflet";
import { useParams } from "react-router-dom";
import AppContext from "../../../context/app-context";

const redIcon = new Icon({
  iconUrl: "/red.png",
  iconSize: [30, 30],
});

const greenIcon = new Icon({
  iconUrl: "/green.png",
  iconSize: [30, 30],
});

const orangeIcon = new Icon({
  iconUrl: "/orange.png",
  iconSize: [30, 30],
});

function parseCoordinates(value) {
  const [lat, lng] = String(value || "").split(",");
  return {
    lat: parseFloat(lat),
    lng: parseFloat((lng || "").trim()),
  };
}

export default function DeviceMap() {
  const { siteCode } = useParams();
  const { addressData } = useContext(AppContext);
  const device = useMemo(
    () => addressData?.find?.((row) => row.site_code === siteCode) || null,
    [addressData, siteCode]
  );

  const position = useMemo(() => parseCoordinates(device?.gps_coordinates), [device]);

  const icon = useMemo(() => {
    const color = String(device?.color || "").toLowerCase();
    if (String(device?.emergency).toLowerCase() === "yes" || color.includes("red")) {
      return redIcon;
    }
    if (String(device?.non_functional).toLowerCase() === "yes" || color.includes("orange")) {
      return orangeIcon;
    }
    return greenIcon;
  }, [device]);

  if (!device || Number.isNaN(position.lat) || Number.isNaN(position.lng)) {
    return (
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ minHeight: 420, background: "#f8fafc" }}
      >
        <div className="text-muted">Loading device location...</div>
      </div>
    );
  }

  return (
    <MapContainer
      center={[position.lat, position.lng]}
      zoom={18}
      style={{ height: 420, width: "100%" }}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Marker position={[position.lat, position.lng]} icon={icon}>
        <Popup>
          <div style={{ minWidth: 220 }}>
            <h6 style={{ marginBottom: 8 }}>{device.bus_stop}</h6>
            <div><strong>Site Code:</strong> {device.site_code}</div>
            <div><strong>Status:</strong> {device.emergency === "yes" ? "Emergency" : device.functional === "yes" ? "Operational" : "Non-operational"}</div>
            <div><strong>Road:</strong> {device.road}</div>
            <div><strong>Towards:</strong> {device.towards}</div>
          </div>
        </Popup>
      </Marker>
    </MapContainer>
  );
}
